import { Fragment } from "react";
import { RouterPaths } from "../../app/appConstants.js";
import { PartnerMenuItemStyled, PartnerMenuStyled } from "./styled/PartnerMenuStyled.js";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { generatePath, matchPath, useLocation } from "react-router";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const PARTNER_MENU = [{
    name: 'main',
    path: RouterPaths.partner,
}, {
    name: 'campaigns',
    path: RouterPaths.partnerCampaigns,
}, {
    name: 'payment',
    path: RouterPaths.partnerPayment,
}, {
    name: 'statistics',
    path: RouterPaths.partnerStats,
}, {
    name: 'support',
    path: RouterPaths.partnerSupport,
}, {
    name: 'api_docs',
    path: generatePath(RouterPaths.partnerApiDocs),
    exact: false,
}
];

function PartnerMenu() {
    const {getLangPath} = useLangContext();
    const location = useLocation();

    return <PartnerMenuStyled>
        {
            PARTNER_MENU.map(item => <Fragment key={item.name}>
                <PartnerMenuItemStyled className={classNames('mb-3', {
                    'active': matchPath(location.pathname, {path: item.path, exact: item.exact ?? true}),
                })}>
                    <Link to={item.path}>
                        {getLangPath(`partner.menu.${item.name}.title`)}
                    </Link>
                </PartnerMenuItemStyled>
            </Fragment>)
        }
    </PartnerMenuStyled>
}

export default PartnerMenu;
